// shoppingcartReducer.js
import { persistReducer } from 'redux-persist';

import { SET_ALL_CART_DATA, SET_ALL_METACART_DATA, SET_METACART_ID_DATA, SET_METACART_QUANTITY_DATA, SET_METACART_TOTALPRICE_DATA, SET_METACART_TOTALPRICEFORMAT_DATA, SET_IPSNOTICE_DATA, SET_IPSPRODUCT_DATA} from '../../actions/cartactions/shoppingcartActions';


const initialState = {
  metacartdata: [ { iddata: null, quantityall: null, totalprice: null, totalpriceformat: null }, ],
  noticedata: null,
  productdata: null,

};

const shoppingcartReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_CART_DATA:
      return {
        ...state,
        metacartdata: action.payload.metacartdata,
        noticedata: action.payload.noticedata,
        productdata: action.payload.productdata
      };
    case SET_ALL_METACART_DATA:
      return {
        ...state,
        metacartdata: action.payload
      };
    case SET_METACART_ID_DATA:
      return {
        ...state,
        metacartdata: state.metacartdata.map(item =>
          item.id === action.payload.id ? { ...item, iddata: action.payload.id } : item
        )
      };
    case SET_METACART_QUANTITY_DATA:
      return {
        ...state,
        metacartdata: state.metacartdata.map(item =>
          item.id === action.payload.id ? { ...item, quantityall: action.payload.quantityall } : item
        )
      };
    case SET_METACART_TOTALPRICE_DATA:
      return {
        ...state,
        metacartdata: state.metacartdata.map(item =>
          item.id === action.payload.id ? { ...item, totalprice: action.payload.totalprice } : item
        )
      };
    case SET_METACART_TOTALPRICEFORMAT_DATA:
      return {
        ...state,
        metacartdata: state.metacartdata.map(item =>
          item.id === action.payload.id ? { ...item, totalpriceformat: action.payload.totalpriceformat } : item
        )
      };
      case SET_IPSNOTICE_DATA:
        return {
          ...state,
          noticedata: action.payload
        };
      case SET_IPSPRODUCT_DATA:
        return {
          ...state,
          productdata: action.payload
        };
      default:
        return state;
    }
  
 
  
};



//export default persistedReducer;
export default shoppingcartReducer;